import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const SearchResultComponent = (props) => {
    const [t] = useTranslation("common");
    const maintheme = useSelector((state) => state.themeData.maintheme);
    return (
        <Box
            style={{
                display: 'flex',
                backgroundColor:maintheme?.gray,
                padding:'10px',
                borderRadius:'10px',
                marginLeft:'10px',
                marginRight:'10px',

            }}
        >
            <Typography sx={{
                fontFamily: 'Cairo',
            }}>{t('GLOBAL.SEARCH_RESULT_OF_SEARCH')}  {props?.resultLength}
            </Typography>
        </Box>
    );
};

export default SearchResultComponent;
